/* K-Beauty Store, homepage CRO. Eén script voor alle home-* secties.
   Geen libraries. Elke sectie initialiseert via data-kb-init="naam".
   Cart via het Blockshop custom element `cart-element` (zie bouwplan blog, besluit 19). */
(function () {
  'use strict';
  if (window.KBHome) return;

  var KB = window.KBHome = { inits: {}, config: window.KBHomeConfig || {} };

  /* ---------- helpers ---------- */
  var store = {
    get: function (k, fallback) { try { var v = localStorage.getItem(k); return v === null ? fallback : JSON.parse(v); } catch (e) { return fallback; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };
  KB.store = store;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  KB.qs = qs; KB.qsa = qsa;

  function eur(cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + n;
  }
  KB.eur = eur;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = function () { return window.innerWidth < 768; };
  KB.isMobile = isMobile;

  function track(section, action, value) {
    var payload = { section: section, action: action, value: value === undefined ? null : value };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('home_interaction', payload); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'home_interaction', home_section: section, home_action: action, home_value: payload.value }); } catch (e) {}
  }
  KB.track = track;

  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'kb-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }
  KB.toast = toast;

  /* ---------- cart ---------- */
  function addItems(items, buttonEl, source) {
    items = items.map(function (it) {
      var props = it.properties || {};
      if (source) props._source = source;
      return { id: it.id, quantity: it.quantity || 1, properties: props };
    });
    var Cart = window.customElements && customElements.get('cart-element');
    if (Cart && typeof Cart.addItems === 'function') {
      return Cart.addItems({
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: Cart.sections })
      }, buttonEl);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }).then(function (j) {
      document.dispatchEvent(new CustomEvent('theme:cart:updated'));
      window.location.href = '/cart';
      return j;
    });
  }
  KB.addItems = addItems;

  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  KB.fetchCart = fetchCart;

  // Alle losse Toevoegen-knoppen: <button data-add-variant="123" data-source="home-x">
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-variant]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var source = btn.getAttribute('data-source') || 'home';
    addItems([{ id: parseInt(btn.getAttribute('data-add-variant'), 10), quantity: 1 }], btn, source)
      .then(function () { btn.classList.add('is-added'); btn.classList.remove('is-busy'); if (btn.getAttribute('data-added-label')) btn.textContent = btn.getAttribute('data-added-label'); track(source, 'add_to_cart', btn.getAttribute('data-add-variant')); })
      .catch(function () { btn.classList.remove('is-busy'); toast(KB.config.t_add_error || 'Toevoegen is niet gelukt. Probeer het opnieuw.'); });
  });

  /* ---------- levertekst ---------- */
  function deliveryText() {
    var c = KB.config;
    var cutoff = (c.delivery_cutoff || '21:45').split(':');
    var cm = parseInt(cutoff[0], 10) * 60 + parseInt(cutoff[1], 10);
    var now = new Date();
    var day = now.getDay(), mins = now.getHours() * 60 + now.getMinutes();
    if (day >= 1 && day <= 5 && mins < cm) return c.t_delivery_tomorrow || 'Morgen in huis';
    if (day === 5 || day === 6 || day === 0) return c.t_delivery_tuesday || 'Dinsdag in huis';
    return c.t_delivery_tomorrow || 'Morgen in huis';
  }
  KB.deliveryText = deliveryText;
  function fillDelivery(root) {
    if (KB.config.show_delivery === false) return;
    var t = deliveryText();
    qsa('[data-kb-delivery]', root).forEach(function (el) { el.textContent = t; });
  }

  /* ---------- slider helper ---------- */
  // <div data-kb-slider><div class="kb-track">…</div><button data-prev></button><button data-next></button><span data-pager></span><div data-dots></div></div>
  function slider(root) {
    var track = qs('.kb-track', root);
    if (!track) return null;
    var prev = qs('[data-prev]', root), next = qs('[data-next]', root), pager = qs('[data-pager]', root), dots = qs('[data-dots]', root);
    var items = function () { return qsa(':scope > *', track); };
    function perPage() {
      var first = items()[0]; if (!first) return 1;
      var w = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      return Math.max(1, Math.round(track.clientWidth / w));
    }
    function pages() { return Math.max(1, Math.ceil(items().length / perPage())); }
    function page() {
      var first = items()[0]; if (!first) return 0;
      var w = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      return Math.min(pages() - 1, Math.round(track.scrollLeft / (w * perPage())));
    }
    function update() {
      var p = page(), n = pages();
      if (prev) prev.disabled = p <= 0;
      if (next) next.disabled = p >= n - 1;
      if (pager) pager.textContent = (KB.config.t_page || 'Pagina') + ' ' + (p + 1) + ' ' + (KB.config.t_of || 'van') + ' ' + n;
      if (dots) {
        if (dots.children.length !== n) { dots.innerHTML = ''; for (var i = 0; i < n; i++) { var d = document.createElement('span'); d.className = 'kb-dot'; dots.appendChild(d); } }
        qsa('.kb-dot', dots).forEach(function (d, i) { d.classList.toggle('is-active', i === p); });
      }
    }
    function go(delta) {
      var first = items()[0]; if (!first) return;
      var w = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      track.scrollBy({ left: delta * w * perPage(), behavior: reducedMotion ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    return { go: go, update: update, track: track, page: page, pages: pages, goTo: function (i) { var first = items()[i]; if (first) track.scrollTo({ left: first.offsetLeft - track.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' }); } };
  }
  KB.slider = slider;

  /* ---------- tabs helper ---------- */
  // [role=tablist] > button[role=tab][aria-controls=id]; panels [role=tabpanel][id]
  function tabs(root, onChange) {
    var list = qs('[role="tablist"]', root); if (!list) return;
    var tabsEls = qsa('[role="tab"]', list);
    function activate(tab) {
      tabsEls.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (onChange) onChange(tab);
    }
    tabsEls.forEach(function (t) {
      t.addEventListener('click', function () { activate(t); });
      t.addEventListener('keydown', function (e) {
        var i = tabsEls.indexOf(t);
        if (e.key === 'ArrowRight') { e.preventDefault(); tabsEls[(i + 1) % tabsEls.length].focus(); tabsEls[(i + 1) % tabsEls.length].click(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); tabsEls[(i - 1 + tabsEls.length) % tabsEls.length].focus(); tabsEls[(i - 1 + tabsEls.length) % tabsEls.length].click(); }
      });
    });
    return { activate: activate, tabs: tabsEls };
  }
  KB.tabs = tabs;

  /* ---------- dialoog helper ---------- */
  function openDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); }
    else { dlg.setAttribute('open', ''); }
    var close = qs('[data-close]', dlg);
    if (close && !close._bound) { close._bound = true; close.addEventListener('click', function () { closeDialog(dlg); }); }
    if (!dlg._bound) {
      dlg._bound = true;
      dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDialog(dlg); });
    }
    var f = qs('button, a, [tabindex]', dlg); if (f) f.focus();
  }
  function closeDialog(dlg) { if (typeof dlg.close === 'function' && dlg.open) dlg.close(); else dlg.removeAttribute('open'); }
  KB.openDialog = openDialog; KB.closeDialog = closeDialog;

  /* ---------- init ---------- */
  function initSection(el) {
    if (el._kbInit) return;
    var name = el.getAttribute('data-kb-init');
    fillDelivery(el);
    if (name && KB.inits[name]) { try { KB.inits[name](el); } catch (e) { if (window.console) console.warn('KBHome init', name, e); } }
    el._kbInit = true;
  }
  var booted = false;
  KB.register = function (name, fn) {
    KB.inits[name] = fn;
    if (booted) qsa('[data-kb-init="' + name + '"]').forEach(function (el) { el._kbInit = false; initSection(el); });
  };
  function initAll() { qsa('[data-kb-init]').forEach(initSection); }
  document.addEventListener('shopify:section:load', function (e) { qsa('[data-kb-init]', e.target).forEach(function (el) { el._kbInit = false; initSection(el); }); if (e.target.hasAttribute && e.target.hasAttribute('data-kb-init')) { e.target._kbInit = false; initSection(e.target); } });

  /* =====================================================================
     Secties
     ===================================================================== */

  /* 01 Story-rij */
  KB.register('stories', function (root) {
    var seen = store.get('kbs-seen', []);
    qsa('[data-story]', root).forEach(function (btn) {
      var id = btn.getAttribute('data-story');
      if (seen.indexOf(id) > -1) btn.classList.add('is-seen');
      btn.addEventListener('click', function (e) {
        if (seen.indexOf(id) === -1) { seen.push(id); store.set('kbs-seen', seen); }
        btn.classList.add('is-seen');
        track('home-stories', 'open', id);
        var dlg = qs('[data-story-dialog="' + id + '"]', root);
        if (dlg) { e.preventDefault(); openDialog(dlg); }
      });
    });
  });

  /* 02 Hero-slider */
  KB.register('hero', function (root) {
    var s = slider(root); if (!s) return;
    var interval = parseInt(root.getAttribute('data-interval') || '6000', 10);
    var timer, paused = false;
    function tick() { if (paused || reducedMotion || document.hidden) return; if (s.page() >= s.pages() - 1) s.goTo(0); else s.go(1); }
    function start() { stop(); if (interval > 0 && !reducedMotion) timer = setInterval(tick, interval); }
    function stop() { clearInterval(timer); }
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    root.addEventListener('touchstart', function () { stop(); }, { passive: true });
    s.track.addEventListener('scroll', function () { var p = s.page(); if (root._lastPage !== p) { root._lastPage = p; track('home-hero', 'slide', p + 1); var live = qs('[data-live]', root); if (live) live.textContent = 'Slide ' + (p + 1) + ' van ' + s.pages(); } }, { passive: true });
    start();
  });

  /* 04 Recent gezocht */
  KB.register('recent-search', function (root) {
    // Zoektermen vastleggen op /search
    var q = null;
    try { q = new URL(window.location.href).searchParams.get('q'); } catch (e) {}
    if (window.location.pathname.indexOf('/search') > -1 && q) {
      var hist = store.get('kbs-searches', []).filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      hist.unshift(q); store.set('kbs-searches', hist.slice(0, 8));
    }
    var list = store.get('kbs-searches', []);
    var wrap = qs('[data-recent]', root), popular = qs('[data-popular]', root), label = qs('[data-label]', root);
    if (list.length && wrap) {
      wrap.innerHTML = list.map(function (term) { var a = document.createElement('a'); a.className = 'kb-chip'; a.href = '/search?q=' + encodeURIComponent(term); a.setAttribute('data-kb-search-term', term); a.textContent = term; return a.outerHTML; }).join('');
      wrap.hidden = false; if (popular) popular.hidden = true;
      if (label) label.textContent = root.getAttribute('data-label-recent') || label.textContent;
    } else if (popular && popular.children.length === 0) {
      root.hidden = true;
    }
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('a.kb-chip');
      var open = e.target.closest('[data-kb-open-search]');
      if (!chip && !open) return;
      if (chip) track('home-recent-search', 'click', chip.textContent);

      // Zelfde trigger als het zoek-icoon in de header (Blockshop top-drawer, view "search")
      var trigger = document.querySelector('.header--search[data-drawer-open]');
      if (!trigger) return; // geen drawer: de href /search?q= doet zijn werk

      e.preventDefault();
      trigger.click();

      var term = chip ? (chip.getAttribute('data-kb-search-term') || chip.textContent.trim()) : '';
      var tries = 0;
      (function fill() {
        // Hello Retail-overlay eerst, anders de Blockshop-drawer
        var input = document.querySelector('#hr-search input[type="search"]') || document.querySelector('#search_input');
        var shown = input && input.getBoundingClientRect().width > 0;
        if (!shown) { if (++tries < 30) setTimeout(fill, 50); return; }
        if (term) {
          input.value = term;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
        }
        input.focus();
      })();
    });
  });

  /* 05 Huidbehoefte */
  KB.register('needs', function (root) {
    root.addEventListener('click', function (e) { var a = e.target.closest('[data-need]'); if (a) track('home-needs', 'click', a.getAttribute('data-need')); });
    var more = qs('[data-needs-more]', root);
    if (more) more.addEventListener('click', function () {
      var open = root.classList.toggle('is-expanded');
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = open ? (more.getAttribute('data-less') || 'Minder tonen') : (more.getAttribute('data-more') || 'Toon alle huidbehoeften');
      track('home-needs', open ? 'more' : 'less');
    });
  });

  /* 02b Verzend-countdown */
  KB.register('countdown', function (root) {
    var out = qs('[data-countdown]', root); if (!out) return;
    function parse(t) { var a = (t || '0:0').split(':'); return parseInt(a[0], 10) * 60 + parseInt(a[1], 10); }
    var start = parse(root.getAttribute('data-start') || '17:00');
    function tick() {
      var cutoff = parse(KB.config.delivery_cutoff || '21:45');
      var d = new Date(), day = d.getDay(), mins = d.getHours() * 60 + d.getMinutes();
      var show = day >= 1 && day <= 5 && mins >= start && mins < cutoff;
      root.hidden = !show;
      if (show) { var left = cutoff - mins; out.textContent = (Math.floor(left / 60) ? Math.floor(left / 60) + 'u ' : '') + (left % 60) + 'm'; }
    }
    tick(); setInterval(tick, 30000);
  });

  /* 07 Productslider met tabs, inclusief "Voor jou" */
  KB.register('product-tabs', function (root) {
    var sliders = {};
    qsa('[role="tabpanel"]', root).forEach(function (panel) { var s = slider(panel); if (s) sliders[panel.id] = s; });
    var t = tabs(root, function (tab) {
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel && sliders[panel.id]) sliders[panel.id].update();
      var title = qs('[data-tab-title]', root); if (title && tab.getAttribute('data-title')) title.textContent = tab.getAttribute('data-title');
      var cta = qs('[data-tab-cta]', root); if (cta && tab.getAttribute('data-cta')) cta.href = tab.getAttribute('data-cta');
      track('home-product-tabs', 'tab', tab.getAttribute('data-key'));
    });
    var youTab = qs('[data-key="you"]', root), youPanel = qs('[data-you-panel]', root);
    var labels = {}; try { labels = JSON.parse(root.getAttribute('data-need-labels') || '{}'); } catch (e) {}
    // Voor jou: filter op need-tag uit de quiz (bij laden en live na de quiz)
    function applyYou(need) {
      if (!need || !youTab || !youPanel || !labels[need]) return false;
      var seenIds = {}, picks = [];
      qsa('[role="tabpanel"]:not([data-you-panel]) [data-product-needs]', root).forEach(function (card) {
        var id = card.getAttribute('data-product-id');
        if (seenIds[id]) return;
        var needs = (card.getAttribute('data-product-needs') || '').split(',');
        if (needs.indexOf(need) > -1) { seenIds[id] = 1; picks.push(card.cloneNode(true)); }
      });
      var min = parseInt(root.getAttribute('data-you-min') || '3', 10);
      if (picks.length < min) return false;
      var track_ = qs('.kb-track', youPanel); track_.innerHTML = '';
      picks.slice(0, 12).forEach(function (c) { c.querySelectorAll('.is-added').forEach(function (b) { b.classList.remove('is-added'); }); track_.appendChild(c); });
      youTab.hidden = false;
      youTab.textContent = (root.getAttribute('data-you-label') || 'Voor jou') + ' · ' + labels[need];
      youTab.setAttribute('data-title', (root.getAttribute('data-you-title') || 'Geselecteerd voor jouw') + ' ' + labels[need].toLowerCase());
      sliders[youPanel.id] = slider(youPanel);
      if (t) t.activate(youTab);
      return true;
    }
    applyYou(store.get('kbs-quiz-need', ''));
    document.addEventListener('kb:quiz', function (e) { applyYou(e.detail && e.detail.need); });
    document.addEventListener('kb:quiz:reset', function () { if (youTab) { youTab.hidden = true; var first = qsa('[role="tab"]:not([hidden])', root)[0]; if (first && t) t.activate(first); } });
    fillDelivery(root);
  });

  /* 08 Routine */
  KB.register('routine', function (root) {
    tabs(root, function (tab) { track('home-routine', 'tab', tab.getAttribute('data-key')); });
    qsa('[data-routine-all]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('[role="tabpanel"]') || root;
        var ids = qsa('[data-routine-variant]', panel).map(function (el) { return parseInt(el.getAttribute('data-routine-variant'), 10); }).filter(Boolean);
        if (!ids.length) return;
        btn.classList.add('is-busy'); btn.setAttribute('aria-disabled', 'true');
        addItems(ids.map(function (id) { return { id: id, quantity: 1 }; }), btn, 'home-routine')
          .then(function () { btn.classList.remove('is-busy'); btn.removeAttribute('aria-disabled'); track('home-routine', 'add_all', ids.length); })
          .catch(function () { btn.classList.remove('is-busy'); btn.removeAttribute('aria-disabled'); toast(KB.config.t_add_error || 'Toevoegen is niet gelukt.'); });
      });
    });
  });

  /* 09 Huidquiz */
  KB.register('quiz', function (root) {
    var pool = []; try { pool = JSON.parse(qs('[data-quiz-pool]', root).textContent); } catch (e) {}
    var groups = qsa('[data-quiz-group]', root);
    var picks = {};
    var status = qs('[data-quiz-status]', root), submit = qs('[data-quiz-submit]', root), result = qs('[data-quiz-result]', root), resultGrid = qs('[data-quiz-grid]', root), resultTitle = qs('[data-quiz-title]', root), resetBtn = qs('[data-quiz-reset]', root);
    var titles = {}; try { titles = JSON.parse(root.getAttribute('data-result-titles') || '{}'); } catch (e) {}
    function left() { return groups.length - Object.keys(picks).length; }
    function refresh() {
      var n = left();
      var tLeft = root.getAttribute('data-t-left') || '[n] van 2 nog te kiezen';
      if (status) status.textContent = n > 0 ? (tLeft.indexOf('[n]') > -1 ? tLeft.replace('[n]', n) : n + ' ' + tLeft) : (root.getAttribute('data-t-ready') || 'Klaar');
      if (submit) submit.disabled = n > 0;
    }
    groups.forEach(function (g) {
      var key = g.getAttribute('data-quiz-group');
      qsa('[data-quiz-answer]', g).forEach(function (btn) {
        btn.addEventListener('click', function () {
          picks[key] = btn.getAttribute('data-quiz-answer');
          qsa('[data-quiz-answer]', g).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          var chosen = qs('[data-quiz-chosen]', g); if (chosen) chosen.textContent = btn.textContent.trim();
          if (Object.keys(picks).length === 1) track('home-quiz', 'start');
          refresh();
        });
      });
    });
    function render() {
      var needs = Object.keys(picks).map(function (k) { return picks[k]; });
      var primary = needs[needs.length - 1];
      var scored = pool.map(function (p) {
        var s = 0; needs.forEach(function (n) { if ((p.needs || []).indexOf(n) > -1) s += 2; });
        if (p.bestseller) s += 1;
        return { p: p, s: s };
      }).sort(function (a, b) { return b.s - a.s; }).slice(0, 3);
      if (resultGrid) {
        resultGrid.innerHTML = scored.map(function (x) {
          var p = x.p;
          var add = p.variant && p.available ? '<button class="kb-add kb-add--icon" type="button" data-add-variant="' + p.variant + '" data-source="home-quiz" data-added-label="✓" aria-label="Toevoegen">+</button>' : '<a class="kb-add kb-add--icon" href="' + p.url + '" aria-label="Bekijk">→</a>';
          return '<article class="kb-card kb-card--compact" data-product-id="' + p.id + '"><div class="kb-card__media-wrap"><a class="kb-card__media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" width="400" height="400">' : '<span class="kb-placeholder"></span>') + '</a></div><div class="kb-card__body"><span class="kb-card__vendor">' + (p.vendor || '') + '</span><a class="kb-card__title" href="' + p.url + '">' + p.title + '</a><div class="kb-card__foot"><span class="kb-price">' + eur(p.price) + '</span>' + add + '</div></div></article>';
        }).join('');
      }
      if (resultTitle) resultTitle.textContent = titles[primary] || titles._default || '';
      var form = qs('[data-quiz-form]', root); if (form && root.getAttribute('data-replace-form') === 'true') form.hidden = true;
      if (result) { result.hidden = false; result.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' }); }
      store.set('kbs-quiz-need', primary);
      track('home-quiz', 'complete', needs.join('+'));
      document.dispatchEvent(new CustomEvent('kb:quiz', { detail: { need: primary } }));
    }
    if (submit) submit.addEventListener('click', function () { if (left() === 0) render(); });
    if (resetBtn) resetBtn.addEventListener('click', function () { picks = {}; store.del('kbs-quiz-need'); qsa('[data-quiz-answer]', root).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); }); qsa('[data-quiz-chosen]', root).forEach(function (el) { el.textContent = ''; }); if (result) result.hidden = true; var form = qs('[data-quiz-form]', root); if (form) form.hidden = false; document.dispatchEvent(new CustomEvent('kb:quiz:reset')); refresh(); track('home-quiz', 'reset'); });
    qsa('[data-quiz-apply]', root).forEach(function (a) { a.addEventListener('click', function () { track('home-quiz', 'apply'); }); });
    refresh();
  });

  /* 10 Shop per merk */
  KB.register('brands', function (root) {
    var panelWrap = qs('[data-brand-panels]', root);
    var more = qs('[data-brand-more]', root);
    qsa('[data-brand]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-brand');
        var active = btn.getAttribute('aria-expanded') === 'true';
        qsa('[data-brand]', root).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        qsa('[data-brand-panel]', root).forEach(function (p) { p.hidden = true; });
        if (active) return;
        btn.setAttribute('aria-expanded', 'true');
        var panel = qs('[data-brand-panel="' + key + '"]', root);
        if (panel) { panel.hidden = false; slider(panel); panel.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' }); }
        track('home-brands', 'open', key);
      });
    });
    if (more) more.addEventListener('click', function () { var open = root.classList.toggle('is-expanded'); more.setAttribute('aria-expanded', open ? 'true' : 'false'); more.textContent = open ? (more.getAttribute('data-less') || 'Minder merken') : (more.getAttribute('data-more') || 'Toon meer merken'); track('home-brands', open ? 'more' : 'less'); });
    if (panelWrap) panelWrap.addEventListener('click', function (e) { var c = e.target.closest('[data-close]'); if (c) { qsa('[data-brand]', root).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); qsa('[data-brand-panel]', root).forEach(function (p) { p.hidden = true; }); } });
  });

  /* 11 Reviews */
  KB.register('reviews', function (root) {
    var s = slider(root);
    var filters = qsa('[data-skin]', root);
    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        var skin = f.getAttribute('data-skin');
        filters.forEach(function (x) { x.setAttribute('aria-selected', x === f ? 'true' : 'false'); });
        qsa('[data-review-skin]', root).forEach(function (card) { card.hidden = skin !== 'all' && card.getAttribute('data-review-skin') !== skin; });
        if (s) { s.track.scrollTo({ left: 0 }); s.update(); }
        track('home-reviews', 'filter', skin);
      });
    });
  });

  /* 12 Glow Points */
  KB.register('points', function (root) {
    var range = qs('input[type="range"]', root); if (!range) return;
    var perEuro = parseFloat(root.getAttribute('data-points-per-euro') || '1');
    var euroPer100 = parseFloat(root.getAttribute('data-euro-per-100') || '5');
    var maskPoints = parseFloat(root.getAttribute('data-mask-points') || '0');
    var maskThreshold = parseFloat(root.getAttribute('data-mask-threshold') || '30');
    function calc() {
      var m = parseFloat(range.value);
      var pts = Math.round(m * 12 * perEuro);
      var disc = Math.floor(pts / 100) * euroPer100;
      var masks = maskPoints > 0 ? Math.floor(pts / maskPoints) : (maskThreshold > 0 ? Math.floor(m / maskThreshold) * 12 : 0);
      var set = function (sel, v) { var el = qs(sel, root); if (el) el.textContent = v; };
      set('[data-out-month]', '€' + m);
      set('[data-out-points]', pts.toLocaleString('nl-NL'));
      set('[data-out-discount]', '€' + disc);
      set('[data-out-masks]', masks);
      range.style.setProperty('--kb-fill', ((m - range.min) / (range.max - range.min) * 100) + '%');
    }
    range.addEventListener('input', calc);
    range.addEventListener('change', function () { track('home-points', 'slider', range.value); });
    calc();
  });

  /* 13 Winkel: open/gesloten in Europe/Amsterdam */
  KB.register('store', function (root) {
    var hours = []; try { hours = JSON.parse(root.getAttribute('data-hours') || '[]'); } catch (e) {}
    var badge = qs('[data-open-badge]', root); if (!badge || !hours.length) return;
    var closedDates = (root.getAttribute('data-closed-dates') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    function nowAms() {
      try {
        var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', year: 'numeric', month: '2-digit', day: '2-digit', hour12: false });
        var parts = {}; f.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
        var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        return { day: days[parts.weekday], mins: parseInt(parts.hour, 10) % 24 * 60 + parseInt(parts.minute, 10), date: parts.year + '-' + parts.month + '-' + parts.day };
      } catch (e) { var d = new Date(); return { day: d.getDay(), mins: d.getHours() * 60 + d.getMinutes(), date: '' }; }
    }
    var n = nowAms();
    var today = hours[n.day]; // [open, close] in "HH:MM" of null
    var open = false;
    if (today && today[0] && closedDates.indexOf(n.date) === -1) {
      var o = today[0].split(':'), c = today[1].split(':');
      var om = parseInt(o[0], 10) * 60 + parseInt(o[1], 10), cm = parseInt(c[0], 10) * 60 + parseInt(c[1], 10);
      open = n.mins >= om && n.mins < cm;
    }
    badge.textContent = open ? (root.getAttribute('data-t-open') || 'Nu open') : (root.getAttribute('data-t-closed') || 'Nu gesloten');
    badge.classList.toggle('is-open', open);
    badge.classList.toggle('is-closed', !open);
    badge.hidden = false;
  });

  /* 15 Shopbare video's */
  KB.register('videos', function (root) {
    var track_ = qs('[data-video-track]', root) || qs('.kb-track', root);
    var items = qsa('[data-video-item]', root);
    var videos = qsa('video', root);
    var saveData = navigator.connection && navigator.connection.saveData;
    var muted = true, playing = true, active = Math.min(parseInt(root.getAttribute('data-start-index') || '1', 10), Math.max(0, items.length - 1));
    var live = qs('[data-live]', root);
    function play(v) { if (reducedMotion || saveData || !playing) return; v.muted = muted; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function layout() {
      if (!track_ || !items.length) return;
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === active); });
      videos.forEach(function (v) { var it = v.closest('[data-video-item]'); if (it && it.classList.contains('is-active')) play(v); else v.pause(); });
      var el = items[active];
      var offset = (root.clientWidth / 2) - (el.offsetLeft + el.offsetWidth / 2);
      var trackW = track_.scrollWidth, viewW = root.clientWidth;
      if (trackW <= viewW) { offset = (viewW - trackW) / 2; }
      else { offset = Math.min(0, Math.max(viewW - trackW, offset)); }
      track_.style.transform = 'translateX(' + offset + 'px)';
      if (live) live.textContent = 'Video ' + (active + 1) + ' van ' + items.length + (el.getAttribute('data-caption') ? ': ' + el.getAttribute('data-caption') : '');
      qsa('[data-prev]', root).forEach(function (b) { b.disabled = active <= 0; });
      qsa('[data-next]', root).forEach(function (b) { b.disabled = active >= items.length - 1; });
    }
    function go(i) { active = Math.max(0, Math.min(items.length - 1, i)); layout(); track('home-videos', 'focus', active + 1); }
    items.forEach(function (it, i) { it.addEventListener('click', function (e) { if (i !== active && !e.target.closest('a, [data-add-variant], [data-mute], [data-play]')) { e.preventDefault(); go(i); } }); });
    qsa('[data-prev]', root).forEach(function (b) { b.addEventListener('click', function () { go(active - 1); }); });
    qsa('[data-next]', root).forEach(function (b) { b.addEventListener('click', function () { go(active + 1); }); });
    var tx = null;
    root.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (tx === null) return; var dx = e.changedTouches[0].clientX - tx; tx = null; if (Math.abs(dx) > 40) go(active + (dx < 0 ? 1 : -1)); }, { passive: true });
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(active + 1); if (e.key === 'ArrowLeft') go(active - 1); });
    root.addEventListener('click', function (e) {
      var m = e.target.closest('[data-mute]'), p = e.target.closest('[data-play]');
      if (m) { e.stopPropagation(); muted = !muted; videos.forEach(function (v) { v.muted = muted; }); qsa('[data-mute]', root).forEach(function (b) { b.setAttribute('aria-pressed', muted ? 'false' : 'true'); b.setAttribute('aria-label', muted ? (root.getAttribute('data-t-unmute') || 'Geluid aan') : (root.getAttribute('data-t-mute') || 'Geluid uit')); }); root.classList.toggle('is-unmuted', !muted); track('home-videos', muted ? 'mute' : 'unmute'); }
      if (p) { e.stopPropagation(); playing = !playing; root.classList.toggle('is-paused', !playing); qsa('[data-play]', root).forEach(function (b) { b.setAttribute('aria-pressed', playing ? 'true' : 'false'); }); videos.forEach(function (v) { var it = v.closest('[data-video-item]'); if (playing && it && it.classList.contains('is-active')) play(v); else v.pause(); }); track('home-videos', playing ? 'play' : 'pause'); }
    });
    videos.forEach(function (v) { v.addEventListener('play', function () { if (!v._tracked) { v._tracked = true; track('home-videos', 'play', v.getAttribute('data-handle') || ''); } }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting) { videos.forEach(function (v) { var it = v.closest('[data-video-item]'); if (it && it.classList.contains('is-active')) play(v); }); } else { videos.forEach(function (v) { v.pause(); }); } }, { threshold: 0.3 }).observe(root);
    }
    window.addEventListener('resize', layout);
    layout();
  });

  /* 16 Instagram-grid */
  KB.register('instagram', function (root) {
    var more = qs('[data-ig-more]', root);
    if (more) more.addEventListener('click', function () { root.classList.add('is-expanded'); more.hidden = true; track('home-instagram', 'more'); });
  });

  /* 19 Sticky mobiele balk */
  KB.register('sticky-bar', function (root) {
    var bar = root;
    var cartView = qs('[data-bar-cart]', bar), quizView = qs('[data-bar-quiz]', bar), youView = qs('[data-bar-you]', bar), subtotal = qs('[data-bar-subtotal]', bar), count = qs('[data-bar-count]', bar), toTop = qs('[data-to-top]', bar) || qs('[data-to-top]');
    var quizLink = bar.getAttribute('data-quiz-link') || '#quiz';
    var isQuizLink = quizLink === '#quiz';
    var scrollFactor = parseFloat(bar.getAttribute('data-scroll-factor') || '2');
    var quizSection = document.getElementById(quizLink.charAt(0) === '#' ? quizLink.slice(1) : 'quiz');
    var state = { cart: 0, subtotal: 0, quizVisible: false, drawerOpen: false, scrolled: false, need: store.get('kbs-quiz-need', ''), quizDone: isQuizLink && !!store.get('kbs-quiz-need', '') };
    function render() {
      var mobile = isMobile();
      var showCart = mobile && state.cart > 0 && !state.drawerOpen;
      var showQuiz = mobile && state.cart === 0 && state.scrolled && !state.quizVisible && !state.drawerOpen && !state.quizDone && !!quizView;
      var show = showCart || showQuiz;
      bar.classList.toggle('is-visible', show);
      bar.classList.toggle('is-cart', showCart);
      bar.classList.toggle('is-quiz', showQuiz);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (cartView) cartView.hidden = !showCart;
      if (quizView) quizView.hidden = !showQuiz;
      if (youView) youView.hidden = true;
      if (subtotal) subtotal.textContent = eur(state.subtotal);
      if (count) count.textContent = state.cart;
      if (toTop) { toTop.hidden = !state.scrolled; toTop.classList.toggle('is-lifted', showCart || showQuiz); }
    }
    function refreshCart() { fetchCart().then(function (c) { state.cart = c.item_count; state.subtotal = c.items_subtotal_price; render(); }).catch(function () {}); }
    window.addEventListener('scroll', function () { var s = window.scrollY > window.innerHeight * scrollFactor; if (s !== state.scrolled) { state.scrolled = s; render(); } }, { passive: true });
    window.addEventListener('resize', render);
    document.addEventListener('theme:cart:updated', refreshCart);
    document.addEventListener('theme:cart:productAdded', refreshCart);
    document.addEventListener('kb:quiz', function (e) { state.need = e.detail.need; state.quizDone = isQuizLink; render(); });
    document.addEventListener('kb:quiz:reset', function () { state.need = ''; state.quizDone = false; render(); });
    if (quizSection && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { state.quizVisible = en[0].isIntersecting; render(); }, { threshold: 0.2 }).observe(quizSection);
    var mo = new MutationObserver(function () { var d = qs('cart-element'); state.drawerOpen = !!(d && (d.hasAttribute('open') || d.classList.contains('is-open') || d.classList.contains('active') || document.body.classList.contains('cart-open'))); render(); });
    mo.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'open'] });
    qsa('[data-bar-open-cart]', bar).forEach(function (b) { b.addEventListener('click', function (e) { var d = qs('cart-element'); var trigger = qs('[data-cart-toggle], a[href="/cart"], [href$="/cart"]'); track('home-sticky-bar', 'cart'); if (d && typeof d.open === 'function') { e.preventDefault(); d.open(); } else if (trigger) { e.preventDefault(); trigger.click(); } }); });
    qsa('a', bar).forEach(function (a) { a.addEventListener('click', function () { track('home-sticky-bar', 'click', a.getAttribute('href')); }); });
    if (toTop) toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' }); track('home-sticky-bar', 'top'); });
    refreshCart();
    render();
  });

  /* ---------- start ---------- */
  function boot() { booted = true; initAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
